import storage from 'proxy-storage';
import memoize from '../../../utils/fp/memoize';
import getLocationByZip from '../../../core/get-location-by-zip';
import getLocationByIp from '../../../core/getLocationByIp';
import zip from '../../validator/rules/zipcode';
import getSession from '../../session-manager/getSession';
import defaultSessionPayload from '../../session-manager/sessionPayload';
import checkZipCodeChangesInUrl from '../../session-manager/_checkZipCodeChangesInUrl';
import getFPL from '../../../core/getFPL';

const fetchLocationInfo = (zipChanged) => {
  if (zipChanged && zip({value: zipChanged}).isValid) return getLocationByZip(zipChanged, false);
  return null;
};

const updateLocationInfo = (geoInfo, hcStorage, fromIP) => {
  hcStorage.location.zip_code = geoInfo.zipCode || '';
  hcStorage.location.state = geoInfo.stateName || '';
  hcStorage.location.state_acronym = geoInfo.stateAcronym || '';
  hcStorage.location.county = geoInfo.countyName || '';
  hcStorage.location.city = geoInfo.city || '';
  hcStorage.locationFromIP = fromIP;
  if (fromIP) hcStorage.ip_address = geoInfo.ip_address || '';
  return hcStorage;
};

const fetchLocationByIp = (zipFound) => {
  if (!zipFound || !zip({value: zipFound}).isValid) return getLocationByIp();
  return {};
};

/**
 * @param {String} email If is present, should validate the session with this email
 * @param {*} payloadReducer If is present, should use as a reducer payload
 * @returns {Object} Return a session payload
 */
function getSessionPayload(email, payloadReducer) {
  defaultSessionPayload.Email = email || null;

  if (payloadReducer && typeof payloadReducer === 'function') {
    return payloadReducer(defaultSessionPayload);
  }

  return defaultSessionPayload;
}

/**
 * @public
 * Detect changes and update the `hc` storage with values from the URL.
 * @param {String} email If is present, should validate the session with this email
 * @param {*} payloadReducer If is present, should use as a reducer payload
 *
 * @return {Promise}
 */
function loadData(email, payloadReducer) {
  let hcStorage;
  const sessionPayload = getSessionPayload(email, payloadReducer);

  // Update location if a new valid zipcode has been detected in URL
  return getSession(sessionPayload)
    .then((response) => {
      hcStorage = response.hcStorage;
      return response;
    })
    .then(() => checkZipCodeChangesInUrl(hcStorage))
    .then(fetchLocationInfo)
    .then(geoInfo => geoInfo && updateLocationInfo(geoInfo, hcStorage, false))
    .then(() => hcStorage.location.zip_code)
    .then(fetchLocationByIp)
    .then(geoIp => geoIp.postal && updateLocationInfo({
      zipCode: geoIp.postal || '',
      stateName: geoIp.region || '',
      stateAcronym: geoIp.region_code || '',
      countyName: geoIp.county || '',
      city: geoIp.city || '',
      ip_address: geoIp.ip || '',
    }, hcStorage, true))
    .then(() => {
      if (!hcStorage.household.size || !hcStorage.household.income) {
        return {};
      }

      return getFPL(hcStorage);
    })
    .then((fplResp) => {
      if (fplResp.data && typeof fplResp.data === 'number') {
        hcStorage.household.fpl = fplResp.data;
      }

      return hcStorage;
    })
    .then(() => {
      hcStorage.source = hcStorage.source || sessionPayload.Label.Src;
      return hcStorage;
    })
    .then(() => {
      // updates the 'hc' object with values from the URL
      storage.setItem('hc', hcStorage);
      return hcStorage;
    });
}

export default memoize(loadData);
